function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var t = ["Shift", "Meta", "Alt", "Control"],
    e = "object" == (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) && /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "Meta" : "Control";

function n(t, e) {
  return "function" == typeof t.getModifierState && t.getModifierState(e);
}

function r(t) {
  return t.trim().split(" ").map(function (t) {
    var n = t.split(/\b\+/),
        r = n.pop();
    return [n = n.map(function (t) {
      return "$mod" === t ? e : t;
    }), r];
  });
}

function o(e, o) {
  var i;
  void 0 === o && (o = {});
  var u = null != (i = o.timeout) ? i : 1e3,
      a = Object.keys(e).map(function (t) {
    return [r(t), e[t]];
  }),
      f = new Map(),
      c = null;
  return function (e) {
    e instanceof KeyboardEvent && (a.forEach(function (r) {
      var o = r[0],
          i = r[1],
          u = f.get(o) || o;
      !function (e, r) {
        return !(r[1].toUpperCase() !== e.key.toUpperCase() && r[1] !== e.code || r[0].find(function (t) {
          return !n(e, t);
        }) || t.find(function (t) {
          return !r[0].includes(t) && r[1] !== t && n(e, t);
        }));
      }(e, u[0]) ? n(e, e.key) || f.delete(o) : u.length > 1 ? f.set(o, u.slice(1)) : (f.delete(o), i(e));
    }), c && clearTimeout(c), c = setTimeout(f.clear.bind(f), u));
  };
}

function i(t, e, n) {
  var r;
  void 0 === n && (n = {});
  var i = null != (r = n.event) ? r : "keydown",
      u = o(e, n);
  return t.addEventListener(i, u), function () {
    t.removeEventListener(i, u);
  };
}

export default i;
export { o as createKeybindingsHandler, r as parseKeybinding };